// extracted by mini-css-extract-plugin
export default {"payment-method-container":"PaymentMethod_payment-method-container__uKQOp","btn":"PaymentMethod_btn__9L0Xr"};